import * as React from "react";
import { mergeOverrides, useStyletron } from "baseui";
import { Block } from "baseui/block";
import { ListItem, ListItemLabel } from "baseui/list";
import { PLACEMENT, StatefulPopover, TRIGGER_TYPE } from "baseui/popover";

import { Button } from "kanopi-components/Button";
import { expandPadding } from "../utils/styles";

/* eslint-disable react/prop-types */
// TODO: Enable the proptype check next time when this file is changed

type TDocument = {
  name: string;
  url: string;
};

export function DocumentDownloader(props) {
  const { documents = [], children, overrides = {}, ...rest } = props;

  return (
    <StatefulPopover
      accessibilityType={"menu"}
      triggerType={TRIGGER_TYPE.click}
      placement={PLACEMENT.bottom}
      showArrow
      overrides={mergeOverrides(
        {
          Arrow: {
            style: ({ $theme }) => ({
              backgroundColor: $theme.colors.backgroundPrimary,
            }),
          },
          Inner: {
            style: ({ $theme }) => ({
              backgroundColor: $theme.colors.backgroundPrimary,
              ...expandPadding($theme.sizing.scale300),
            }),
          },
          Body: {
            style: ({ $theme }) => ({
              backgroundColor: $theme.colors.backgroundPrimary,
            }),
          },
        },
        overrides
      )}
      content={<FileList documents={documents} />}
      {...rest}
    >
      {children}
    </StatefulPopover>
  );
}

export type TFileList = {
  documents: TDocument[];
};
export const FileList: React.FC<TFileList> = ({ documents }) => {
  const [css] = useStyletron();

  const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) newWindow.opener = null;
  };

  const onClickUrl =
    (url: string): (() => void) =>
    () =>
      openInNewTab(url);

  return (
    <Block data-testid="fileList">
      <ul
        className={css({
          width: "100%",
          paddingLeft: 0,
          paddingRight: 0,
        })}
      >
        {documents.map(({ name, url }, index) => (
          <ListItem
            key={index}
            endEnhancer={() => (
              <Button
                size={Button.SIZE.compact}
                kind={Button.KIND.primary}
                shape={Button.SHAPE.pill}
                onClick={onClickUrl(url)}
                NORMAL_WIDTH_RESET={true}
                data-testid={name}
              >
                View
              </Button>
            )}
            overrides={{
              Root: {
                style: () => ({
                  backgroundColor: "transparent",
                }),
              },
            }}
          >
            <ListItemLabel
              overrides={{
                LabelContent: {
                  style: ({ $theme }) => ({
                    ...$theme.typography.LabelSmall,
                    paddingRight: $theme.sizing.scale600,
                  }),
                },
              }}
            >
              {name}
            </ListItemLabel>
          </ListItem>
        ))}
      </ul>
    </Block>
  );
};
